import { HierarchyArea } from '@plarium/hierarchy-react';
import React from 'react';

import { FormFieldArray } from '@gogame/form';

import Invoices from './Invoices';

const InvoicesFieldArray = ({
  name,
  depends,
  source,
  disabled,
  active,
  financialResultCurrency,
}) => {
  return (
    <HierarchyArea
      name={name}
      depends={depends}
      lazy={false}
      source={source}
      active={active}
    >
      {({ area }) => (
        <FormFieldArray name={name}>
          {({ push, replace, remove, form }) => {
            return (
              <Invoices
                {...area.data}
                name={name}
                financialResultCurrency={financialResultCurrency}
                error={area?.error}
                loading={area.loading}
                attachDisabled={disabled}
                items={form.values[name]}
                onAdd={push}
                onReplace={replace}
                onRemove={remove}
              />
            );
          }}
        </FormFieldArray>
      )}
    </HierarchyArea>
  );
};

export default InvoicesFieldArray;
